function isObject(item: unknown) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function deepMerge<T extends object[]>(...objects: T): Record<string, unknown> {
  return objects.reduce<Record<string, unknown>>((acc, currentObject = {}) => {
    Object.keys(currentObject).forEach((key) => {
      const accValue = acc[key];
      const currentValue = (currentObject as Record<string, unknown>)[key];

      if (Array.isArray(accValue) && Array.isArray(currentValue)) {
        acc[key] = [...accValue, ...currentValue];
      } else if (isObject(accValue) && isObject(currentValue)) {
        acc[key] = deepMerge(accValue as object, currentValue as object);
      } else {
        acc[key] = currentValue;
      }
    });
    return acc;
  }, {});
}
